module.exports = __webpack_public_path__ + "img/AddFriendsIcon.b624d0cc.svg";